import { projectResolutionQuery } from '@/entities/project';
import { useDeepLinkResolution, type DeepLinkResolutionState } from '@/shared/hooks';

/**
 * The shared seam's state union under the project name, so `ProjectDetail`
 * and its tests stay decoupled from the shared module's naming.
 */
export type ProjectResolutionState = DeepLinkResolutionState;

/**
 * Project binding of the entity deep-link seam — see `useDeepLinkResolution`
 * for the full outcome contract (ready / silent switch / access-denied /
 * not-found / cross-org prompt).
 */
export function useProjectResolution(projectId: string | undefined): ProjectResolutionState {
  return useDeepLinkResolution({
    resolutionQuery: projectResolutionQuery(projectId),
    enabled: !!projectId,
  });
}
